exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-select_t[data-v-4657d3dc]  .el-select__tags{white-space:nowrap;overflow:hidden;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.el-select_t[data-v-4657d3dc]  .el-select__tags-text{max-width:36px;display:inline-block;text-overflow:ellipsis;overflow:hidden;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.status-select[data-v-4657d3dc]  .el-input__inner:not([tabindex]){height:40px!important}.status-select[data-v-4657d3dc]  .el-input .el-input__icon{line-height:40px!important}", ""]);

// exports
